import $ from 'jquery';
import Mustache from 'mustache';

class Message {

  constructor ( element ) {

    let selector = element.data( 'action-target' );
    this._target = $( selector );
    selector += '__template'
    this._template = $( selector ).html();

    this._message = element.data( 'error-message' );

  }

  show() {
    this._target.html( Mustache.render( this._template, { message: this._message } ) )
  }

  static _jQueryInterface ( method ) {
    return this.each( function () {
      let element = $( this );
      let data = element.data( '_message' );

      if ( ! data ) {
        data = new Message( element );
        $( this ).data( '_message', data );
      }

      if ( typeof method === 'string' ) {
        if ( typeof data[method] === 'undefined' ) {
          throw new TypeError( `No method named "${method}"` );
        }
        data[ method ]();
      }
    } );
  }
}

/**
 * ------------------------------------------------------------------------
 * Data Api implementation
 * ------------------------------------------------------------------------
 */


/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 */

$.fn.message             = Message._jQueryInterface;
$.fn.message.Constructor = Message;

export default Message;